export interface MealRecord {
  id: string;
  mealType: "breakfast" | "lunch" | "dinner";
  name: string;
  category: string;
  quantity: number;
  unit: string;
  weight: number;
  calories: number;
  protein: number;
  carbs: number;
  fat: number;
  fiber: number;
  vitC: number;
  time: string;
}

export const mealRecords: MealRecord[] = [
  {
    id: "r1",
    mealType: "breakfast",
    name: "燕麦牛奶",
    category: "主餐",
    quantity: 1,
    unit: "碗",
    weight: 250,
    calories: 180,
    protein: 8,
    carbs: 28,
    fat: 4,
    fiber: 3,
    vitC: 0,
    time: "08:12",
  },
  {
    id: "r2",
    mealType: "breakfast",
    name: "水煮蛋",
    category: "其他",
    quantity: 1,
    unit: "个",
    weight: 50,
    calories: 70,
    protein: 6,
    carbs: 1,
    fat: 5,
    fiber: 0,
    vitC: 0,
    time: "08:12",
  },
  {
    id: "r3",
    mealType: "breakfast",
    name: "蓝莓",
    category: "水果",
    quantity: 1,
    unit: "盒",
    weight: 60,
    calories: 34,
    protein: 0.4,
    carbs: 8,
    fat: 0.2,
    fiber: 1.4,
    vitC: 5.8,
    time: "08:12",
  },
  {
    id: "r4",
    mealType: "lunch",
    name: "米饭",
    category: "主餐",
    quantity: 1,
    unit: "碗",
    weight: 180,
    calories: 210,
    protein: 4,
    carbs: 46,
    fat: 0.6,
    fiber: 0.5,
    vitC: 0,
    time: "12:30",
  },
  {
    id: "r5",
    mealType: "lunch",
    name: "西红柿炒蛋",
    category: "菜",
    quantity: 1,
    unit: "份",
    weight: 200,
    calories: 280,
    protein: 10,
    carbs: 14,
    fat: 20,
    fiber: 2.4,
    vitC: 30,
    time: "12:30",
  },
  {
    id: "r6",
    mealType: "lunch",
    name: "清炒时蔬",
    category: "菜",
    quantity: 1,
    unit: "份",
    weight: 150,
    calories: 60,
    protein: 2,
    carbs: 6,
    fat: 3,
    fiber: 3.3,
    vitC: 30,
    time: "12:30",
  },
];

export const mealTargets = {
  breakfast: 500,
  lunch: 800,
  dinner: 700,
};

export const totalTarget = 2000;